if (!customElements.get('free-shipping-text')) {
  customElements.define('free-shipping-text', class extends HTMLElement {
    connectedCallback() {
      // Threshold is set in the shop currency, convert it to the customer's currency
      const rate = parseFloat(window.Shopify?.currency?.rate) || 1;
      this.threshold = Math.round((parseInt(this.dataset.threshold, 10) || 0) * rate);
      this.productInfo = this.closest('product-info');

      // Initial state from the variant that is actually selected on the page
      const selected = this.productInfo?.querySelector('variant-selects [data-selected-variant]');
      if (selected) {
        try {
          this.update(JSON.parse(selected.textContent));
        } catch (e) {}
      }

      if (typeof subscribe === 'function') {
        this.unsubscribe = subscribe(theme.PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const sectionId = this.productInfo?.dataset.originalSection || this.productInfo?.dataset.section;
          if (sectionId && data.sectionId !== sectionId) return;
          this.update(data.variant);
        });
      }
    }

    disconnectedCallback() {
      this.unsubscribe?.();
    }

    update(variant) {
      if (!variant || typeof variant.price !== 'number') return;
      const isAbove = variant.price >= this.threshold;
      this.querySelector('[data-free-shipping-above]')?.toggleAttribute('hidden', !isAbove);
      this.querySelector('[data-free-shipping-below]')?.toggleAttribute('hidden', isAbove);
    }
  });
}
